import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { BrandGroupSelect } from "components";
import { createFormHelper } from "lib/Form";
import { useTagsQuery } from "modules/CheckInServices/components/LocationServicesList/hooks";

import type { DealerServiceFormValues } from "modules/CheckInServices/components";

type DealerServiceFormProps = {
  hasErrors: boolean;
};

const FormHelper = createFormHelper<DealerServiceFormValues>();

export const DealerServiceForm = ({ hasErrors }: DealerServiceFormProps) => {
  const { t } = useTranslation();
  const { watch } = FormHelper.useFormContext();

  const { tagsOptions } = useTagsQuery();

  const [name, description] = watch(["name", "description"]);

  return (
    <>
      <Form.Field required error={!name && hasErrors}>
        <label>{t("v8_service_name", "Service name")}</label>
        <FormHelper.Field.Input name="name" inputProps={{ placeholder: t("v8_name", "Name"), fluid: true }} />
      </Form.Field>

      <Form.Field required error={!description && hasErrors}>
        <label>{t("v8_service_description", "Service description")}</label>
        <FormHelper.Field.Input name="description" inputProps={{ placeholder: t("v8_description", "Description"), fluid: true }} />
      </Form.Field>

      <Form.Field>
        <label>{t("v8_brand_groups", "Brand Groups")}</label>
        <FormHelper.Controller name="brand_group_ids" render={({ field }) => <BrandGroupSelect value={field.value} onChange={field.onChange} />} />
      </Form.Field>

      <Form.Field>
        <label>{t("v8_select_tag", "Select tag")}</label>
        <FormHelper.Field.Dropdown name="tag_id" options={tagsOptions} dropdownProps={{ placeholder: t("v8_tags", "Tags"), fluid: true, clearable: true }} />
      </Form.Field>

      <Form.Field>
        <label>{t("v8_info_url", "Info URL")}</label>
        <FormHelper.Field.Input name="info_url" inputProps={{ placeholder: t("v8_url", "URL"), fluid: true }} />
      </Form.Field>

      <Form.Field>
        <label>{`${t("v8_price_excl_vat", "Price excl. VAT")}`}</label>
        <FormHelper.Field.Input name="price" inputProps={{ placeholder: t("v8_price", "Price"), fluid: true }} isPriceInput />
      </Form.Field>

      <Form.Group inline>
        <Form.Field>
          <FormHelper.Field.Checkbox name="hide_for_lease_appointments" label={t("v8_hide_for_lease_appointments", "Hide for lease appointments")} />
        </Form.Field>

        <Form.Field>
          <FormHelper.Field.Checkbox name="can_convert_to_intervention" label={t("v8_convert_to_intervention", "Convert to intervention")} />
        </Form.Field>
      </Form.Group>
    </>
  );
};
